import { apiPaths } from 'app/services/api';
import React from 'react';
import { MOBILE_REGEX } from '../../smart-kit/Form/gridFormUtils';
import CrudGridForm from '../../smart-kit/Form/CrudGridForm';
import { provinces } from '../agents/AgentForm';

const fields = [
  // main
  {
    label: 'Mobile Number',
    type: 'number',
    key: 'mobile_number',
    validation: { required: true, pattern: { value: MOBILE_REGEX, message: 'not a valid mobile' } },
  },
  {
    label: 'Role',
    key: 'roles',
    type: 'selectMultiple',
    items: [
      { value: 'sa', label: 'Super Admin' },
      // { value: 'admin', label: 'Business Manager' },
      { value: 'sales_manager', label: 'Sales Manager' },
      { value: 'finance', label: 'Finance' },
      { value: 'insurance_manager', label: 'Insurance Manager' },
      { value: 'cs', label: 'Customer Support' },
      { value: 'hamrah_tel', label: 'Hamrahtel' },
      // { value: 'gsm_seller', label: 'GSM seller' },
      // { value: 'agent', label: 'Agent' },
    ],
    validation: { required: true },
  },

  {
    label: 'Insurance',
    key: 'insurance_uuid',
    validation: { required: true },
    type: 'auto_complete',
    options: { entity: 'insurances', path: apiPaths.INSURANCES, render: ['name'] },
    show: {
      key: 'roles',
      value: 'insurance_manager',
    },
  },

  // { label: 'Gender', key: 'gender', type: 'radio', items: [{ value: 'male', label: 'Male' }, { value: 'female', label: 'Female' }, { value: 'other', label: 'Other' }], validation: { required: false } },
  {
    label: 'Name',
    group: 'Name',
    groupIndex: 0,
    key: 'first_name',
    validation: { required: true },
  },
  {
    label: 'Last Name',
    group: 'Name',
    groupIndex: 1,
    key: 'last_name',
    validation: { required: true },
  },
  // { label: 'Bimeh', key: 'bimeh', validation: { required: true } },
  // { label: 'English Name', group: 'English Name', groupIndex: 0, key: 'eng_first_name', validation: { required: true } },
  // { label: 'English Last Name', group: 'English Name', groupIndex: 1, key: 'eng_last_name', validation: { required: true } },

  {
    label: 'City',
    key: 'city',
    validation: { required: false },
    type: 'select',
    items: provinces.map((province) => ({
      value: province.slug,
      label: province.name,
    })),
  },
  {
    label: 'Profile Pic',
    key: 'profile_pic',
    type: 'image',
    purpose: 'profile_pic',
    validation: { required: false },
  },
  // {label: 'National Card Pic', key:'national_card_pic', type:'image', purpose: 'national_card_pic', validation: {required: false}},

  // { label: 'Birth Date', key: 'birth_date', type: 'date', validation: { required: false } },
];
const UserForm = () => {
  return <CrudGridForm path={apiPaths.USERS} name="User" entityName={'sellers'} fields={fields} />;
};

export default UserForm;
